module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": true
    },
    on: {
      "closemodal": _vm.assignCopy
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Price Settings")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "m-4 text-center"
  }, [_c('loader')], 1) : _c('div', [(!_vm.isPricePerGroup) ? _c('div', {
    staticClass: "bg-color-1 lightest text-right p-4"
  }, [(_vm.getProductEditPriceData.audienceType) ? _c('div', {
    staticClass: "text-uppercase"
  }, [_vm._v("\n                    Total per " + _vm._s(_vm.audienceIdToName(_vm.getProductEditPriceData.audienceType)) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total-value"
  }, [_vm._v("\n                    " + _vm._s(_vm.totalPVP) + " €\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 pl-5 pt-2"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Component Type")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-select', {
    class: {
      'notAllowed': _vm.getProductEditPriceData.isDisabled
    },
    attrs: {
      "options": _vm.types,
      "label": "description",
      "placeholder": "-Search type-",
      "disabled": _vm.getProductEditPriceData.isDisabled
    },
    on: {
      "input": function($event) {
        return _vm.updateComponentRuleType(_vm.descriptionAudienceTypes)
      }
    },
    model: {
      value: (_vm.descriptionAudienceTypes),
      callback: function($$v) {
        _vm.descriptionAudienceTypes = $$v
      },
      expression: "descriptionAudienceTypes"
    }
  }), _vm._v(" "), (_vm.hasRuleGroupsAssociated) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Fixed decomposed prices are only available when there is no rule groups in product'),
      expression: "'Fixed decomposed prices are only available when there is no rule groups in product'"
    }],
    staticClass: "d-flex align-items-center ml-3 color-6 fa fa-info-circle fs-large"
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.getProductEditPriceData.componentRuleType != 0 && !_vm.isPricePerGroup) ? _c('div', {
    staticClass: "col-sm-5 pl-5 mt-3 total-price-min-height"
  }, [_c('div', {
    staticClass: "my-2"
  }, [_c('label', {
    staticClass: "bold"
  }, [_vm._v("Total Price "), (_vm.getProductEditPriceData.value == null) ? _c('span', {
    staticClass: "color-6 bold ml-1"
  }, [_vm._v("*")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.getProductEditPriceData.value),
      expression: "getProductEditPriceData.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "glued-right py-[1.5px]",
    staticStyle: {
      "width": "5rem"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.getProductEditPriceData.isDisabled
    },
    domProps: {
      "value": (_vm.getProductEditPriceData.value)
    },
    on: {
      "change": function($event) {
        return _vm.updateValuePrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.getProductEditPriceData, "value", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left py-[1.5px]"
  }, [_vm._v("€")])]), _vm._v(" "), (_vm.hasServiceValueError) ? _c('div', {
    staticClass: "mt-1 error text-nowrap"
  }, [_c('span', [_vm._v("The service value cannot be equal to or less than 0€")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-4"
  }, [_c('split-price-editor', {
    attrs: {
      "isToLoadUpdateRowToStore": _vm.isToLoadUpdateRowToStore,
      "disabled": _vm.getProductEditPriceData.isDisabled,
      "priceObj": _vm.getProductEditPriceData,
      "componentRuleType": _vm.componentRuleType,
      "isPricePerGroup": _vm.isPricePerGroup
    },
    on: {
      "row-is-ready-to-save": function($event) {
        return _vm.isReadyToSave($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center justify-content-end",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": !_vm.isReadyToBeSaved && _vm.getProductEditPriceData.componentRuleType !== 1 || _vm.getProductEditPriceData.isDisabled || _vm.hasServiceValueError
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d8862f8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8862f8e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ProductEditPrice.vue
// module id = 1512
// module chunks = 0